/**
 * Comparator for fractional-indexing order strings.
 *
 * Handles nullable / numeric values gracefully so callers can pass
 * `item.order` directly without coercion.
 *
 * Usage:
 * ```ts
 * list.sort((a, b) => compareFractionalOrder(a.order, b.order));
 * ```
 */
export function compareFractionalOrder(a?: string | number | null, b?: string | number | null): number {
  const orderANum: number | null = toFiniteNumber(a);
  const orderBNum: number | null = toFiniteNumber(b);

  if (orderANum !== null && orderBNum !== null) {
    if (orderANum < orderBNum) return -1;
    if (orderANum > orderBNum) return 1;
    return 0;
  }

  const orderAStr: string = String(a ?? "");
  const orderBStr: string = String(b ?? "");
  if (orderAStr < orderBStr) return -1;
  if (orderAStr > orderBStr) return 1;
  return 0;
}

function toFiniteNumber(value?: string | number | null): number | null {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "string") {
    const parsed: number = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
